import { createRoutine } from 'redux-saga-routines';
import { RETRIEVE_ME } from './types';
/* eslint-disable import/prefer-default-export */

export const retrieveMe = createRoutine(RETRIEVE_ME);
